import { render, staticRenderFns } from "./PatientDetailAppeal.vue?vue&type=template&id=fed2f8bc&scoped=true"
import script from "./PatientDetailAppeal.vue?vue&type=script&lang=js"
export * from "./PatientDetailAppeal.vue?vue&type=script&lang=js"
import style0 from "./PatientDetailAppeal.vue?vue&type=style&index=0&id=fed2f8bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed2f8bc",
  null
  
)

export default component.exports